/* EMM — optimistic variant price update.
   The theme re-renders the product section via the Section Rendering API on
   variant change (full server round trip, ~0.5-1.5s). All variant prices are
   embedded in #emm-variants (market-correct, rendered by Liquid), so paint
   the new price immediately; the section fetch reconciles the rest. */
(function () {
  'use strict';

  function boot() {
    var dataEl = document.getElementById('emm-variants');
    var picker = document.querySelector('variant-selects');
    var priceEl = document.querySelector('.product__right-column .price__main') ||
                  document.querySelector('.price__main');
    if (!dataEl || !picker || !priceEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var sample = priceEl.textContent.trim();
      var m = sample.match(/[\d.,]+/);
      return m ? sample.replace(m[0], amount) : amount;
    }

    picker.addEventListener('change', function () {
      var opts = [];
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { opts.push(r.value); });
      picker.querySelectorAll('select').forEach(function (s) { if (s.value) opts.push(s.value); });
      if (!opts.length) return;
      var match = variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
      if (match && typeof match.price === 'number') {
        priceEl.textContent = fmt(match.price);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
